/**
 * Routen und global sichtbare Modals.
 */

import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from './komponenten/Shell';
import { Login } from './seiten/Login';
import { MeineAufgaben } from './seiten/MeineAufgaben';
import { Cockpit } from './seiten/Cockpit';
import { AngebotDetail } from './seiten/AngebotDetail';
import { Kundenstamm } from './seiten/Kundenstamm';
import { Finanzen } from './seiten/Finanzen';
import { Auftraege } from './seiten/Auftraege';
import { NeuesAngebot } from './seiten/NeuesAngebot';
import { Vorschlaege } from './seiten/Vorschlaege';
import { VorschlagDetail } from './seiten/VorschlagDetail';
import { Buchhaltungsvorbereitung } from './seiten/Buchhaltungsvorbereitung';
import { AdminCenterModal } from './modals/AdminCenterModal';
import { ProfilModal } from './modals/ProfilModal';
import { ChangelogModal } from './modals/ChangelogModal';
import { useKora } from './zustand';

export function App() {
  const { angemeldet, ladend, meta, nutzer, modal, modalOeffnen } = useKora();

  // Hinweis auf eine neue Version: einmal pro Nutzer und Version.
  useEffect(() => {
    if (!nutzer || !meta || modal) return;
    const neueste = meta.changelog[0]?.version;
    if (neueste && nutzer.gesehenVersion !== neueste) {
      modalOeffnen({ art: 'changelog', alle: false });
    }
    // Absichtlich nur an Nutzer und Meta gebunden – sonst öffnet sich das Fenster erneut.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nutzer?.id, meta?.version]);

  if (ladend) {
    return (
      <div className="app-laden">
        <span>Kora wird geladen …</span>
      </div>
    );
  }

  if (!angemeldet) return <Login />;

  return (
    <>
      <Shell>
        <Routes>
          <Route path="/" element={<MeineAufgaben />} />
          <Route path="/cockpit" element={<Geschuetzt bereich="monitor" element={<Cockpit />} />} />
          <Route
            path="/angebot/:id"
            element={<Geschuetzt bereich="monitor" element={<AngebotDetail />} />}
          />
          <Route path="/neu" element={<Geschuetzt bereich="monitor" element={<NeuesAngebot />} />} />
          <Route
            path="/kunden"
            element={<Geschuetzt bereich="kunden" element={<Kundenstamm />} />}
          />
          <Route
            path="/auftraege"
            element={<Geschuetzt bereich="auftraege" element={<Auftraege />} />}
          />
          <Route
            path="/finanzen"
            element={<Geschuetzt bereich="finanzen" element={<Finanzen />} />}
          />
          <Route
            path="/buchhaltung"
            element={<Geschuetzt bereich="buchhaltung" element={<Buchhaltungsvorbereitung />} />}
          />
          {/*
            Vorschläge ohne Bereichsprüfung: Jeder darf einbringen und alles
            sehen. Entschieden wird trotzdem nur vom Administrator – das prüft
            der Server, nicht die Navigation.
          */}
          <Route path="/vorschlaege" element={<Vorschlaege />} />
          <Route path="/vorschlaege/:id" element={<VorschlagDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>

      {modal?.art === 'adminCenter' && <AdminCenterModal />}
      {modal?.art === 'profil' && <ProfilModal />}
      {modal?.art === 'changelog' && <ChangelogModal alle={modal.alle} />}
    </>
  );
}

/** Blendet einen Bereich aus, solange er nicht freigeschaltet ist. */
function Geschuetzt({ bereich, element }: { bereich: string; element: React.ReactElement }) {
  const { darf } = useKora();
  if (!darf(bereich)) {
    return (
      <div className="eh-inhalt">
        <div className="eh-karte">
          <div className="eh-titel" style={{ fontSize: 24 }}>
            Kein Zugriff auf diesen Bereich
          </div>
          <p className="eh-hinweis" style={{ marginTop: 10 }}>
            Die Geschäftsführung kann den Bereich im Admin Center freischalten.
          </p>
        </div>
      </div>
    );
  }
  return element;
}
